module.exports = __webpack_public_path__ + "08fbd0471b4d2cc632f34f66d49df476.png";